import DocumentList from '../../../Component/DynamicDocViewer/DocumentList'
import { IMAGE_BASE_PATH_DBRADC } from '../../../Config/Config'
import AuditReportData from '../../../Assets/JSON/AuditReport/AuditReport.json'

const AuditReport = () => {
  return (
    <DocumentList
      data={AuditReportData}
      title="Audit Report"
      basePath={IMAGE_BASE_PATH_DBRADC}
      navigatePath="/AuditReportPageview"
    />
  )
}
export default AuditReport
